var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C4.25719 0 0 4.25689 0 9.5C0 14.7431 4.25719 19 9.5 19C14.7428 19 19 14.7431 19 9.5C19 4.25689 14.7428 0 9.5 0ZM9.5 1.1875C14.0867 1.1875 17.8125 4.91209 17.8125 9.5C17.8125 14.0879 14.0867 17.8125 9.5 17.8125C4.91328 17.8125 1.1875 14.0879 1.1875 9.5C1.1875 4.91209 4.91328 1.1875 9.5 1.1875ZM9.5 2.07812C5.40312 2.07812 2.07812 5.40372 2.07812 9.5C2.07812 13.5963 5.40312 16.9219 9.5 16.9219C13.5969 16.9219 16.9219 13.5963 16.9219 9.5C16.9219 5.40372 13.5969 2.07812 9.5 2.07812ZM8.90625 5.95858C7.89984 6.10286 7.125 6.96944 7.125 8.01562C7.125 9.16245 8.05719 10.0938 9.20312 10.0938H9.79688C10.2897 10.0938 10.6875 10.4928 10.6875 10.9844C10.6875 11.476 10.2897 11.875 9.79688 11.875H7.42188V13.0625H8.90625V13.9531H10.0938V13.0414C11.1002 12.8971 11.875 12.0306 11.875 10.9844C11.875 9.83755 10.9428 8.90625 9.79688 8.90625H9.20312C8.71031 8.90625 8.3125 8.50725 8.3125 8.01562C8.3125 7.524 8.71031 7.125 9.20312 7.125H11.5781V5.9375H10.0938V5.04688H8.90625V5.95858Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_4265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.9f4951fabb5bce23259c083a68d131bd.svg";
export { ForwardRef as ReactComponent };